import { createSlice } from "@reduxjs/toolkit";
import APIService from "../services/api.service";
import { AppDispatch } from "../store";
import { benefitGetAll, benefitCreateOne } from "../api/benefit";

const initialState = {
  aspirations: [],
  resistances: [],
  // Shared, project-wide benefit catalogue. Backing the benefit picker with a
  // single Redux source means a benefit created on one row appears immediately
  // on every other row's picker (no per-popover stale fetch).
  benefits: []
};

export const listSlice = createSlice({
  name: "list",
  initialState,
  reducers: {
    setLists: (state, action) => {
      state.aspirations = action.payload.aspirations ? action.payload.aspirations : [];
      state.resistances = action.payload.resistances ? action.payload.resistances : [];
    },
    setBenefits: (state, action) => {
      state.benefits = action.payload ? action.payload : [];
    },
  },
});

export const {
  setLists,
  setBenefits
} = listSlice.actions;

export default listSlice.reducer;

// Drops entries with a blank description so a phantom empty row (e.g. an
// aspiration draft that leaked into the project-wide list) never shows up in
// the reuse pickers.
const withDescription = (items: any[]) =>
  (items || []).filter((item) => item?.description && item.description.trim() !== '');

export const getLists = () => async (dispatch: AppDispatch) => {
  try {
    await APIService.get("/lists").then((response) => {
      dispatch(setLists({
        aspirations: withDescription(response.data.aspirations),
        resistances: withDescription(response.data.resistances),
      }));
    });
  } catch (e) {
    console.log(e);
    // dispatch(setCustomerError());
  }
};

// Loads the shared project benefit catalogue into the store.
export const getBenefits = () => async (dispatch: AppDispatch) => {
  const res = await benefitGetAll();
  if (res.items) {
    dispatch(setBenefits(res.items));
  }
};

// Creates a benefit, refreshes the shared catalogue, and returns the created
// benefit (so the caller can immediately attach it). Returns null on failure.
export const createBenefitShared = (data: { name: string }) => async (dispatch: AppDispatch) => {
  const res = await benefitCreateOne(data);
  if (!res.message) {
    return null;
  }
  const all = await benefitGetAll();
  if (all.items) {
    dispatch(setBenefits(all.items));
    return all.items.find((b: any) => b.name === data.name) || null;
  }
  return null;
};
